/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Defines the role names for housing organization access control. These roles are used to manage permissions and access levels for users within housing organizations, such as determining who can perform intake tasks or setup configurations.
 * The HousingOrgRoleName enum provides a clear and consistent way to reference these roles throughout the application, ensuring that access control logic is centralized and maintainable.
 */
export enum HousingOrgRoleName {
    INTAKE = 'Intake',
    SETUP = 'Setup',
    MANAGER = 'Manager',
}
